import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      // Service worker registration failures from bots (Google-Read-Aloud, etc.)
      /^Rejected$/,
    ],
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export const wrapCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6;
